module.exports = __webpack_public_path__ + "img/vide5.7b9f8d73.png";